class TransactionManager {
    constructor(storage) {
        this.storage = storage;
    }

    transaction(mode, repositories = [], scope) {
        return this.storage.transaction(
            mode,
            ...repositories.map((r) => r.getTable()),
            scope
        );
    }
}

export default TransactionManager;
